import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

function NavLinks() {
  const [isActive, setIsActive] = useState("");

  function GetLocation() {
    const location = useLocation();
    useEffect(() => {
      const currentPath = location.pathname;
      if (currentPath.includes("work") || currentPath.includes("project") || currentPath.includes("group")) {
        setIsActive("active");
      } else {
        setIsActive("");
      }
    }, [location]);
  }

  GetLocation();

  return (
    <>
      <div className="NavLinks">
        <p>
          <NavLink exact={true} to="/" className={`Blue ${isActive}`}>
            Work
          </NavLink>
        </p>
        <p>
          <NavLink exact={true} to="/about" className="Teal">
            About Me
          </NavLink>
        </p>
      </div>
      <p className="NavSocial">
        <a href="https://www.linkedin.com/in/laura-brown-898b8a52/">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1728_374)">
          <path className="icon-hover" d="M23.1494 0H1.8457C0.825195 0 0 0.805664 0 1.80176V23.1934C0 24.1895 0.825195 25 1.8457 25H23.1494C24.1699 25 25 24.1895 25 23.1982V1.80176C25 0.805664 24.1699 0 23.1494 0ZM7.41699 21.3037H3.70605V9.37012H7.41699V21.3037ZM5.56152 7.74414C4.37012 7.74414 3.4082 6.78223 3.4082 5.5957C3.4082 4.40918 4.37012 3.44727 5.56152 3.44727C6.74805 3.44727 7.70996 4.40918 7.70996 5.5957C7.70996 6.77734 6.74805 7.74414 5.56152 7.74414ZM21.3037 21.3037H17.5977V15.5029C17.5977 14.1211 17.5732 12.3389 15.6689 12.3389C13.7402 12.3389 13.4473 13.8477 13.4473 15.4053V21.3037H9.74609V9.37012H13.3008V11.001H13.3496C13.8428 10.0635 15.0537 9.07227 16.8555 9.07227C20.6104 9.07227 21.3037 11.543 21.3037 14.7559V21.3037V21.3037Z" fill="#040A11"/>
          </g>
          <defs>
          <clipPath id="clip0_1728_374">
          <rect width="25" height="25" fill="white"/>
          </clipPath>
          </defs>
          </svg>
        </a>
        <a href="https://github.com/lauraliz6">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className="icon-hover" fill-rule="evenodd" clip-rule="evenodd" d="M12.5 0C5.59375 0 0 5.73524 0 12.8162C0 18.4873 3.57812 23.2774 8.54687 24.9755C9.17187 25.0877 9.40625 24.7032 9.40625 24.3667C9.40625 24.0624 9.39063 23.0531 9.39063 21.9797C6.25 22.5725 5.4375 21.1947 5.1875 20.4738C5.04687 20.1054 4.4375 18.9679 3.90625 18.6636C3.46875 18.4232 2.84375 17.8305 3.89063 17.8145C4.875 17.7985 5.57813 18.7437 5.8125 19.1281C6.9375 21.0666 8.73438 20.5219 9.45313 20.1855C9.5625 19.3524 9.89062 18.7917 10.25 18.4713C7.46875 18.1509 4.5625 17.0455 4.5625 12.1433C4.5625 10.7496 5.04688 9.59611 5.84375 8.69898C5.71875 8.37857 5.28125 7.06492 5.96875 5.30269C5.96875 5.30269 7.01563 4.96627 9.40625 6.61635C10.4062 6.32799 11.4688 6.1838 12.5313 6.1838C13.5938 6.1838 14.6563 6.32799 15.6563 6.61635C18.0469 4.95025 19.0938 5.30269 19.0938 5.30269C19.7813 7.06492 19.3438 8.37857 19.2188 8.69898C20.0156 9.59611 20.5 10.7335 20.5 12.1433C20.5 17.0615 17.5781 18.1509 14.7969 18.4713C15.25 18.8718 15.6406 19.6408 15.6406 20.8423C15.6406 22.5565 15.625 23.9342 15.625 24.3667C15.625 24.7032 15.8594 25.1037 16.4844 24.9755C21.4219 23.2774 25 18.4713 25 12.8162C25 5.73524 19.4063 0 12.5 0Z" fill="#040A11"/>
        </svg>
        </a>
      </p>
    </>
  );
}

export default NavLinks;
